export default "__VITE_ASSET__DCY5ND$b__"